import * as React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import SpellcheckIcon from '@mui/icons-material/Spellcheck';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import Tooltip from '@mui/material/Tooltip';
import AssignToTemplateModal from './EditImageModal';
import EditImageModal from './AssignToTemplate'

export default function VMImageCard() {
  return (
    <Card
      sx={{
        maxWidth: 345,
        backgroundColor: 'transparent',
        margin: 2,
        boxShadow: 'none',
        border: '1px solid gray',
      }}
    >
      <CardHeader
        title={
          <Typography variant="body1" sx={{ color: 'lightgray', textAlign: 'center', fontSize: '1.2rem', fontWeight: 'bold' }}>
            Cisco Catalyst 9Kv
          </Typography>
        }
      />
      <CardMedia
        style={{ width: "10rem", margin: "0 auto" }}
        component="img"
        width="10rem"
        image="/assets/img/ciscoLogo.png"
        alt="Cisco Image"
      />
      <CardContent>
        <Typography variant="body2" sx={{ color: 'lightgray' }}>
          This is a Cisco Catalyst 9Kv. It is a high-performance, scalable, and secure network switch. It is designed for enterprise and service provider networks.
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
        <EditImageModal />
        <AssignToTemplateModal />
      </CardActions>
    </Card>
  );
}
